module.exports = __webpack_public_path__ + "static/media/ico-counter-plus.57146ee1.svg";